import api from "./api";
import auth from "./auth";

const BASE_URL = "points-service";

export default {
    getDetails() {
        return new Promise((resolve, reject) => {
            api.get("points-service/mechanics/view", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    getPointsRulesList() {
        return new Promise((resolve, reject) => {
            api.get(`${BASE_URL}/mechanics/list`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    getPointsMechanicsList() {
        return new Promise((resolve, reject) => {
            api.get("points-service/mechanics/list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    updateDetails(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "points-service/mechanics/update",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    updateStandardPointsRules(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "points-service/mechanics/update",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    createCustomPointsRules(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_URL}/v2/mechanics/custom/create`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    updateCustomPointsRules(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_URL}/v2/mechanics/custom/update/${payload.uuid}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    getPointsInfo(uuid) {
        return new Promise((resolve, reject) => {
            api.post(
                "points-service/customers/point/totals",
                { customer_uuid: uuid },
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    getCurrentBalance(uuid) {
        return new Promise((resolve, reject) => {
            api.post(
                "points-service/customers/point/current-balance",
                { customer_uuid: uuid },
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    voidDeduction(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "points-service/merchant/deduction/void",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    getAnalyticsA(merchant_uuid) {
        return new Promise((resolve, reject) => {
            api.get("points-service/analytics/analyticsa/" + merchant_uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getBranchItems(merchant_uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "points-service/analytics/getBranchPerformance/" +
                    merchant_uuid,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getRewardItems(merchant_uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "points-service/analytics/getRewardsPerformance/" +
                    merchant_uuid,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getChartData(merchant_uuid, anchorDate, selectedDays) {
        return new Promise((resolve, reject) => {
            api.get(
                "points-service/analytics/getChartData/" +
                    merchant_uuid +
                    "/" +
                    selectedDays +
                    "/" +
                    anchorDate,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
